module.exports = __webpack_public_path__ + "static/media/HEARTWORM_POSITIVE.6a3bde5a.svg";